const allowAllCountries = true
const allowedCountries = ['ch', 'de']

const getTrackerSiteIds = (siteMapping) => {
  const settings = {}
  siteMapping.split(';').filter((mappingString) => mappingString).forEach((mappingString) => {
    const mappingArray = mappingString.split('->')
    settings[mappingArray[0].toLowerCase()] = parseInt(mappingArray[1])
  });
  return settings;
}


export default function getMatomoConfig (route) {
  const cms = route.query.cms && JSON.parse(route.query.cms)

  const country = route.params && route.params.country
  const isCountryAllowed = country && (allowAllCountries || allowedCountries.includes(country))

  const trackerSiteIds = process.env.MATOMO_SITE_MAPPING && getTrackerSiteIds(process.env.MATOMO_SITE_MAPPING)
  const siteId = trackerSiteIds && trackerSiteIds[country]

  return {
    isAllowed: Boolean(!cms && process.env.MATOMO_URL && isCountryAllowed && siteId),
    url: process.env.MATOMO_URL,
    siteId,
  }
}
